export default __webpack_public_path__ + "static/media/local_shipping.75d2d9e7.svg";